export const labelColumnHeaderStyle = () => ({
  '.label-header-divider': {
    width: '1px',
    height: '28px',
    backgroundColor: '#e1dfdd',
    display: 'inline-block',
    margin: '2px 7px 0px 7px',
    verticalAlign: 'middle',
  },
  '.manage-labels-button': {
    fontFamily: 'MsAds MDL2 Assets',
    fontSize: '15px',
    fontWeight: 'normal',
    verticalAlign: 'middle',
    '&::before': {
      content: '"\\E90F"',
    },
  },
  '.manage-labels-button:focus': {
    border: 'none',
    outline: '1px solid !important',
    outlineColor: '#605e5c !important',
    padding: '2px',
    textDecoration: 'none',
  },
});
